import {
  CCOF_CHANGE_FORM_FIELD,
  CCOF_ADD_SERVICE,
  CCOF_REMOVE_SERVICE,
  CCOF_CHANGE_SERVICE_QUANTITY,
  CCOF_CREATE_MATERIAL,
  CCOF_DELETE_MATERIAL,
  CCOF_RESET_FORM,
  CCOF_UPDATE_FILES,
} from '../mutations/available';

export const ccofUpdateFormField = async ({commit}, {context, fieldName, value}) => {
  commit(CCOF_CHANGE_FORM_FIELD, { context, fieldName, value })
}

export const ccofAddService = ({commit}, {context, serviceId}) => {
  commit(CCOF_ADD_SERVICE, { context, serviceId })
}

export const ccofRemoveService = ({commit}, {context, serviceId}) => {
  commit(CCOF_REMOVE_SERVICE, { context, serviceId })
}

export const ccofChangeServiceQuantity = ({commit}, {context, serviceId, quantity}) => {
  commit(CCOF_CHANGE_SERVICE_QUANTITY, {context, serviceId, quantity})
}

export const ccofCreateMaterial = ({commit}, {context, material}) => {
  commit(CCOF_CREATE_MATERIAL, { context, material })
}

export const ccofDeleteMaterial = ({commit}, {context, type, code}) => {
  commit(CCOF_DELETE_MATERIAL, {context, type, code})
}

export const ccofResetForm = ({commit}, context) => {
  commit(CCOF_RESET_FORM, context)
}

export const ccofUpdateFiles = ({commit}, {context, files}) => {
  commit(CCOF_UPDATE_FILES, {context, files})
}